import {IController, IQService, IScope, ITimeoutService} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {$agentFactory} from "../../../agents/$agent.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {RouteRequestsService} from "../../../routes/services/routes-requests.service";
import {LeanPlanningAlertsService} from "../../services/lean-planning-alerts.factory";
import {LeanPlanningDialogService} from "../../services/lean-planning-dialogs-service.factory";
import {LeanPlanningService} from "../../services/lean-planning-service.service";
import {LeanPlanningRequestsService} from "../../services/plan-requests.factory";
import {TaskModel} from "../../../tasks/models/task.model";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {ResizerService} from "../../../commons/services/resizer.service";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {RoutesListPayloadModel} from "../../../routes/models/routes-list-payload.model";
import {TasksFacadeService} from "../../../tasks/angular/services/tasks-facade.service";
import {Subscription} from "rxjs";
import {BranchesDialogService} from "../../../branches/services/branches-dialogs-service.service";
import {
  ResourceAllocationTimeWindowExtModel
} from "../../../resources/models/resource-allocation-time-window-ext.model";
import {ChangeRouteResourceQueryModelModel} from "../../../routes/models/change-route-resource-query-model.model";

export class PlanningRouteCtrl implements IController {
  route: any;
  metaData: any;

  public serviceAreasRef: any;
  public routesRef: any;
  public tasksRef: any;
  public $tasksRefList: any = []
  public agentRef: any = null
  public agentLocationRef = null;
  public highlightTaskId: any = null;
  public suggestionsQueryString: any = undefined;
  public suggestionsServiceAreas: any = [];
  public selectedSuggestionIds: any = [];
  public showMap: boolean = false;
  public optimizing: boolean = false;
  public filterConfig: any = {
    queryString: ''
  };
  public actionsByStatus: any = {};

  // Suggestions
  public suggestedServices: any = [];
  public selectedSuggestedServices: any = [];

  // Timeline
  public timelineEnabled: boolean = false;
  public timelineZoom: any = undefined;

  public selectedTab: number;
  public isEditMode: boolean;
  public isMobileView: any;
  public showMobileMap: any;
  public flexLeft: any;
  public flexRight: any;
  public flexDown: any;
  public flexUp: any;
  public isMouseHorizontalDown: boolean
  public isMouseVerticalDown: boolean
  public routeTasksListType: any;
  public routeCopy: any;
  public agent: any;
  public openInfoSection: any;
  public selectedRoutes: any;
  public isTimelineView: boolean = false;
  public serviceAreaList: any[];
  public tasksSubscription: Subscription;
  public routeMetaData: any;


  constructor(private leanPlanningRequestsService: LeanPlanningRequestsService, private $mdMedia, private confirmDialogService: ConfirmDialogService, private $filter, private $scope: IScope, private leanPlanningService: LeanPlanningService,
              private deliveriesService: DeliveriesService, private routeRequestsService: RouteRequestsService, private leanPlanningConstants, private $agent: $agentFactory, private $agentLocation, private commonsDialogService: CommonsDialogService,
              private resizeService: ResizeService, private $serviceArea, private resizerService: ResizerService, private $timeout: ITimeoutService,
              private bringozLoaderService: BringozLoaderService, private leanPlanningAlertsService: LeanPlanningAlertsService, private $log, private $task, private leanPlanningDialogService: LeanPlanningDialogService, private TimelineService, private $state,
              private $q: IQService, private $route, private tasksFacadeService: TasksFacadeService, private branchesDialogService: BranchesDialogService,
              private commonsConstants,
              private tasksService: TasksService,
              private commonsService: CommonsService,
              private routesService: RoutesService) {
    this.routesRef = $route();
    // this.tasksRef = $task();
  }


  $onInit() {
    this.serviceAreasRef = this.$serviceArea();
    this.actionsByStatus = this.leanPlanningService.getRoutesActionsMap([this.route]);
    this.selectedTab = 0;

    this.isMobileView = this.$mdMedia('xs');
    this.showMobileMap = this.$mdMedia('xs');
    this.flexLeft = this.$mdMedia('xs') ? '100%' : '50%';
    this.flexRight = this.$mdMedia('xs') ? '0%' : '50%';
    this.flexDown = '20%';

    this.isMouseHorizontalDown = false;
    this.isMouseVerticalDown = false;
    this.routeTasksListType = 'taskListExt'; // taskListExt/taskList

    if (this.route.agentId) {
      this._bindAgent(this.route.agentId)
    }

    if (this.route.serviceAreaIdList) {
      this.getServiceAreaList(this.route.serviceAreaIdList);
    }

    if (this.actionsByStatus.editRoute) {
      this.getSuggestedServices(this.route);
    }

    if (!!this.metaData?.length) {
      this.routeMetaData = [];

      const metaDataKeys = this.metaData.map((m) => m.key);

      this.route.metaData?.forEach((metaData) => {
        if (metaDataKeys.includes(metaData.key)) {
          this.routeMetaData.push(metaData.value);
        }
      })
    }

    this.$timeout(1000).then(() => {
      this.onToggleTimeline();
    });

    // Routes Change Event Listener
    this.routesRef.$subscribeToChannelEvents((updatedRoutes, action) => {

      _.forEach(updatedRoutes, (updatedRoute) => {

        // Routes - Remove / Update
        if ((updatedRoute.id === this.route.id) && (action === 'changed' || action === 'partialChanged')) {

          if (!this.agent && _.get(updatedRoute, 'agentId')) {
            this._bindAgent(updatedRoute.agentId)
          }

          if (!_.isEqual(updatedRoute.serviceAreaIdList, this.route.serviceAreaIdList)) {
            this.getServiceAreaList(updatedRoute.serviceAreaIdList);
          }

          const hasTaskIdListChanged = !_.isEqual(updatedRoute['taskIdList'], this.route['taskIdList']);
          const hasTaskIdListExtChanged = !_.isEqual(updatedRoute['taskIdListExt'], this.route['taskIdListExt']);

          if (hasTaskIdListChanged || hasTaskIdListExtChanged) {
            this._updateExpandedRoute(updatedRoute.id).then((route: any) => {
              this.tasksFacadeService.removeAll();
              this.tasksFacadeService.setMany(_.uniqBy(_.concat(route.taskListExt || [], route.taskList || []), 'id'));
            });
          } else {
            updatedRoute.taskList = angular.copy(this.route.taskList);
            updatedRoute.taskListExt = angular.copy(this.route.taskListExt);
            this.route = updatedRoute;
          }

        }
      })

    });

    // Tasks Change Event Listener
    // this.tasksRef.$subscribeToChannelEvents((updatedTasks, action) => {
    //   if (action === 'changed' || action === 'partialChanged') {
    //     let taskListCopy;
    //     let taskListExtCopy;
    //
    //     _.forEach(updatedTasks, task => {
    //       const taskInListIndex = _.findIndex(this.route.taskList, (t: any) => {
    //         return t.id === task.id;
    //       })
    //       const taskInListExtIndex = _.findIndex(this.route.taskListExt, (t: any) => {
    //         return t.id === task.id;
    //       })
    //
    //
    //       if (taskInListIndex > -1) {
    //         if (!taskListCopy) {
    //           taskListCopy = angular.copy(this.route.taskList);
    //         }
    //         taskListCopy.splice(taskInListIndex, 1, task);
    //       }
    //       if (taskInListExtIndex > -1) {
    //         if (!taskListExtCopy) {
    //           taskListExtCopy = angular.copy(this.route.taskListExt);
    //         }
    //         taskListExtCopy.splice(taskInListExtIndex, 1, task);
    //       }
    //
    //     })
    //
    //
    //     if (!!taskListCopy?.length) {
    //       this.route.taskList = angular.copy(taskListCopy);
    //     }
    //
    //     if (!!taskListExtCopy?.length) {
    //       this.route.taskListExt = angular.copy(taskListExtCopy);
    //     }
    //
    //   }
    // });

    this.tasksFacadeService.subscribeToChannels();

    this.tasksFacadeService.setMany(_.uniqBy(_.concat(this.route.taskListExt || [], this.route.taskList || []), 'id'));

    this.tasksSubscription = this.tasksFacadeService.selectAll()
      .subscribe((tasks: TaskModel[]) => {

        let taskListCopy = angular.copy(this.route.taskList);
        let taskListExtCopy = angular.copy(this.route.taskListExt);
        _.forEach(tasks, task => {
          const taskInListIndex = _.findIndex(this.route.taskList, (t: any) => {
            return t.id === task.id;
          })
          const taskInListExtIndex = _.findIndex(this.route.taskListExt, (t: any) => {
            return t.id === task.id;
          })

          if (taskInListIndex > -1) {
            taskListCopy.splice(taskInListIndex, 1, task);
          }
          if (taskInListExtIndex > -1) {
            taskListExtCopy.splice(taskInListExtIndex, 1, task);
          }

        })

        if (!!taskListCopy?.length) {
          this.route.taskList = angular.copy(taskListCopy);
        }

        if (!!taskListExtCopy?.length) {
          this.route.taskListExt = angular.copy(taskListExtCopy);
        }
        this.$timeout(0).then(() => {
        });
      });
  };


  $doCheck() {
    const isCurrentMobile = this.$mdMedia('xs');
    if (isCurrentMobile && !this.isMobileView) {
      this.flexLeft = '100%';
      this.flexRight = '0%';
      this.showMap = false;
    } else if (this.isMobileView && this.$mdMedia('gt-xs')) {
      this.flexLeft = '50%';
      this.flexRight = '50%';
    }
    this.isMobileView = isCurrentMobile;
  };

  $onDestroy() {
    if (this.agentRef) {
      this.agentRef.$destroy();
    }

    if (this.agentLocationRef) {
      this.agentLocationRef.$destroy();
    }


    // this.tasksRef?.$destroyChannel();
    this.routesRef?.$destroyChannel();

    if (this.$tasksRefList.length) {
      _.forEach(this.$tasksRefList, (taskObjectRef) => {
        taskObjectRef.$destroy();
      });
    }

    this.tasksSubscription.unsubscribe();
    this.tasksFacadeService.removeAll();
  }

  onUpdateIsBlockedByUser(isBlockedByUser) {
    this.leanPlanningService.editBlockedState(this.route.id, isBlockedByUser)
      .then((updatedRoute) => {
        this.route = updatedRoute;
      })
  }

  collapseInfoSection(event) {
    event.stopPropagation();
    this.openInfoSection = !this.openInfoSection;
  }

  onTabSelect(selectedTab) {
    this.selectedTab = selectedTab;
  }


  onDividerVerticalDown() {
    this.isMouseVerticalDown = true;
  }


  onDividerHorizontalDown() {
    if (this.timelineEnabled) {
      this.isMouseHorizontalDown = true;
    }
  }


  onDividerMove(event) {
    if (this.isMouseHorizontalDown) {
      this.resizerService.onHorizontalMove(event)
        .then((flex) => {
          this.flexLeft = flex.left;
          this.flexRight = flex.right;
        });
    }
    if (this.isMouseVerticalDown) {
      this.resizerService.onVerticalMove(event)
        .then((flex) => {
          this.flexDown = flex.down;
          this.flexUp = flex.up;
        });
    }
  }

  onDividerMoveDone() {
    this.isMouseHorizontalDown = false;
    this.isMouseVerticalDown = false;
  }

  onToggleEditMode() {
    if (this.routeCopy) {
      this.routeCopy = undefined;
      this.filterConfig.queryString = undefined;
    } else {
      this.routeCopy = angular.copy(this.route);
      this.isTimelineView = false;
    }
  }

  getSuggestedServices(route, showOnSuccess?: any) {
    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.getSuggestedServices(route.rid, _.map((this.suggestionsServiceAreas || []), 'areaId'))
      .then((services) => {
        if (showOnSuccess) {
          this.leanPlanningAlertsService.getSuggestionsSuccess();
        }
        this.suggestedServices = services;
        this.selectedSuggestionIds = [];
      })
      .catch((error) => {
        this.leanPlanningAlertsService.getSuggestionsError();
        this.$log.error('Failed to get suggested services @planningRoute@getSuggestedServices', error)
      })
      .finally(() => {
        this.resizeService.resize();
        this.bringozLoaderService.off();
      })
  }

  onAddSuggestedServices(servicesIds, route) {
    if (!_.isArray(servicesIds)) {
      servicesIds = [servicesIds]
    }
    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.addServicesToRoute(servicesIds, route.rid)
      .then(() => {
        this.getSuggestedServices(route);
        this.leanPlanningAlertsService.addDeliveriesSuccess(route);
      })
      .catch((error) => {
        this.leanPlanningAlertsService.addDeliveriesError();
        this.$log.error('Failed to add delivery to route @planningRoute@onAddSuggestedServices', error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
        // clearAllSelectedSuggestions();
      })
  }


  submitSuggestionsQuery(query) {
    this.suggestionsQueryString = query;
  }

  onSelectSuggestion(serviceId) {
    const selectedIndex = _.findIndex(this.selectedSuggestionIds, function (id) {
      return id === serviceId;
    })
    const selectedIds = angular.copy(this.selectedSuggestionIds);
    if (selectedIndex > -1) {
      selectedIds.splice(selectedIndex, 1);
    } else {
      selectedIds.push(serviceId);
    }
    this.selectedSuggestionIds = selectedIds;
  }


  onToggleSuggestionsSelection(isAllSelected) {
    this.selectedSuggestionIds = !isAllSelected ? _.map(this.suggestedServices, 'id') : [];
  }

  onSuggestionsServiceAreasChange(serviceAreas) {
    this.suggestionsServiceAreas = serviceAreas;
    this.getSuggestedServices(this.route);
  }

  onToggleTasksExpanded() {
    this.routeTasksListType = _.isEqual(this.routeTasksListType, 'taskListExt') ?
      'taskList' : 'taskListExt';
  }

  onAssignRoute(route) {
    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.assignRouteToAgent(route.rid, route.agentId)
      .then(() => {
        this.leanPlanningAlertsService.assignSuccess();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.assignError();
        this.$log.error('Failed to assign route to driver @planningRoute@onAssignRoute', error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onAssignRouteAndSelectDriver(route, ev) {
    let loading = false;
    this.leanPlanningDialogService.manualAssignRoute(ev, route.rid)
      .then((payload) => {
        loading = true;
        this.bringozLoaderService.on();
        return this.leanPlanningRequestsService.assignRouteToAgent(route.rid, payload.agentId, payload.assignServices);
      })
      .then(() => {
        this.leanPlanningAlertsService.assignSuccess();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to assign route to driver @planningRoute@onAssignRouteAndSelectDriver', error);
          this.leanPlanningAlertsService.assignError();
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      });
  }


  onReoptimizedRoute(routeId) {
    this.optimizing = true;
    this.leanPlanningRequestsService.optimizeRoute(routeId)
      .then((optimizedRoute) => {
        this.route = optimizedRoute;
        this.leanPlanningAlertsService.reOptimizeSuccess();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.reOptimizeError();
        this.$log.error('Failed to Optimize route @planningRoute@onRecalcRoute', error);
      })
      .finally(() => {
        this.optimizing = false;
      })
  }


  onHandleUnpackedDeliveries(route, $event) {
    let unpackedDeliveries = [];
    _.forEach(route.serviceList, (service) => {
      const isUnpacked = this.deliveriesService.isDeliveryUnpacked(service.packageList[0].items);
      if (isUnpacked) {
        unpackedDeliveries.push(service);
      }
    });
    this._handleUnpackedDeliveries(route, unpackedDeliveries, $event)
  }

  onResetRoute(route, event) {
    let loading = false;
    this.leanPlanningDialogService.routeReset(route)
      .then((payload) => {
        loading = true;
        this.bringozLoaderService.on();
        return this.routeRequestsService.resetRoutes(route.rid, undefined, undefined, undefined, undefined, payload.resetOnlyAssignAgentServices);
      })
      .then(() => {
        this.leanPlanningAlertsService.resetSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.resetError();
          this.$log.error('Failed to reset route', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off()
        }
      })
  }

  onDeleteRoute(route, event) {
    let loading = false;
    this.confirmDialogService.confirm('Delete Route', 'Are you sure you want to delete this route?', event)
      .then(() => {
        loading = true;
        this.bringozLoaderService.on();
        return this.routeRequestsService.deleteRoutes(route.rid)
      })
      .then(() => {
        this.selectedRoutes = [];
        this.leanPlanningAlertsService.deleteOneSuccess(route);
        this.$state.go('planning-routes');
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.deleteOneError();
          this.$log.error('Failed to delete routes @planningRoute@onDeleteRoute', error);
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }

  onSettingsClick($event) {
    const settings = _.get(this.route, 'optimizationSettings', {});
    this.leanPlanningDialogService.editRouteSettings(settings, $event)
      .then((updatedSettings) => {
        const routePayload = angular.copy(this.route)
        routePayload.optimizationSettings = updatedSettings;
        this._updateRouteSettings(routePayload);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      });
  }

  _updateRouteSettings(route) {
    this.leanPlanningService.updateRouteSettings(route.id, route)
      .then((route) => {
        this.route = route;

        if (this.routeCopy) {
          this.routeCopy = angular.copy(route);
        }
      })
  }

  onToggleTimeline() {
    this.timelineEnabled = !this.timelineEnabled;
    if (this.timelineEnabled) {
      this.flexUp = '70%';
      this.flexDown = '20%';
    } else {
      this.flexUp = '100%';
      this.flexDown = '0%';
    }
  }

  onTimelineZoom(isZoomIn) {
    this.timelineZoom = isZoomIn;
  }


  onZoomChanged() {
    this.timelineZoom = undefined;
  }

  onTaskSelection(taskId) {
    this.highlightTaskId = taskId;
  }

  onMoveTask(serviceId, fromRouteId, toRouteId, fromOrderedIds, toOrderedIds) {
    const payload = this.TimelineService.getMovedTaskPayload([serviceId], fromRouteId, toRouteId, fromOrderedIds, toOrderedIds);

    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.editRoutes(payload)
      .then((updatedRoutes) => {
        this.leanPlanningAlertsService.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error('Failed to change route itinerary @planningRoute@onRouteOrderChange', error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onHighlightedTaskSelect(taskId) {
    this.highlightTaskId = taskId;
  }

  onSearchQueryChanged(queryString) {
    this.filterConfig.queryString = queryString;
  }

  // function onRemoveSelectedTasks(event) {
  //     var tasks = _.filter(ctrl.route[ctrl.routeTasksListType], function (task) {
  //         return _.indexOf(ctrl.selectedTaskIds, task.id) !== -1
  //     });
  //     _removeTasksFromRoute(tasks, event)
  // }


  onRemoveTaskFromRoute(task: TaskModel, event) {
    this._removeTasksFromRoute(task, event)
  }

  onEditTaskBoundEquipment(task, event) {
    this.leanPlanningDialogService.onEditTaskBoundEquipment(task, _.get(this.agent, 'branchIds'), event)
      .then((task: TaskModel) => {
        this._updateInternalTask(task)
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onRouteOrderChange(updatedTasks) {
    const routeCopyRef = angular.copy(this.routeCopy);
    routeCopyRef[this.routeTasksListType] = angular.copy(updatedTasks);

    this.$timeout(0)
      .then(() => {
        this.routeCopy = routeCopyRef;
      })
  }

  onToggleRouteForcedStartTasks(taskIds) {

    if (!taskIds) {
      return;
    }

    if (!_.get(this.routeCopy, 'optimizationSettings')) {
      this.routeCopy.optimizationSettings = {};
    }

    if (!_.get(this.routeCopy, 'optimizationSettings.forcedStartTaskIds')) {
      this.routeCopy.optimizationSettings.forcedStartTaskIds = [];
    }

    const forcedStartTaskIds = angular.copy(this.routeCopy.optimizationSettings.forcedStartTaskIds);

    _.forEach(taskIds, (taskId) => {
      const taskCurrentIndex = _.findIndex(this.routeCopy.optimizationSettings.forcedStartTaskIds, function (id) {
        return id === taskId;
      });

      if (taskCurrentIndex > -1) {
        forcedStartTaskIds.splice(taskCurrentIndex, 1);
      } else {
        forcedStartTaskIds.push(taskId);
        const taskForceEndIndex = _.findIndex(_.get(this.routeCopy, 'optimizationSettings.forcedEndTaskIds'), function (id) {
          return id === taskId;
        });
        if (taskForceEndIndex > 0) {
          this.routeCopy.optimizationSettings.forcedEndTaskIds.splice(taskForceEndIndex, 1);
        }
      }

      this.routeCopy.optimizationSettings.forcedStartTaskIds = forcedStartTaskIds;
    })
  }

  onToggleRouteForcedEndTasks(taskIds) {
    if (!taskIds) {
      return;
    }

    if (!_.get(this.routeCopy, 'optimizationSettings')) {
      this.routeCopy.optimizationSettings = {};
    }

    if (!_.get(this.routeCopy, 'optimizationSettings.forcedEndTaskIds')) {
      this.routeCopy.optimizationSettings.forcedEndTaskIds = [];
    }

    const forcedEndTaskIds = angular.copy(this.routeCopy.optimizationSettings.forcedEndTaskIds);

    _.forEach(taskIds, (taskId) => {
      const taskCurrentIndex = _.findIndex(this.routeCopy.optimizationSettings.forcedEndTaskIds, function (id) {
        return id === taskId;
      });

      if (taskCurrentIndex > -1) {
        forcedEndTaskIds.splice(taskCurrentIndex, 1);
      } else {
        forcedEndTaskIds.push(taskId);
        const taskForceStartIndex = _.findIndex(_.get(this.routeCopy, 'optimizationSettings.forcedStartTaskIds'), function (id) {
          return id === taskId;
        });
        if (taskForceStartIndex > 0) {
          this.routeCopy.optimizationSettings.forcedStartTaskIds.splice(taskForceStartIndex, 1);
        }
      }

      this.routeCopy.optimizationSettings.forcedEndTaskIds = forcedEndTaskIds;
    })
  }

  onSaveChanges() {
    this._editRoute(_.map(this.routeCopy[this.routeTasksListType], 'id'), this.routeCopy.optimizationSettings);
  }

  onCancelChanges() {
    this.route = angular.copy(this.routeCopy);
    this.routeCopy = undefined;
  }

  onUpdateResource(route) {
    this.leanPlanningDialogService.updateResource(route)
      .then((payload: {
        allocation: ResourceAllocationTimeWindowExtModel,
        queries: ChangeRouteResourceQueryModelModel
      }) => {
        this._reCreateRoute(route, payload.allocation, payload.queries);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })

  }

  onUpdateLogisticsVehicle() {
    this.leanPlanningDialogService.onUpdateRouteBoundEquipment(this.route, _.get(this.agent, 'branchIds'), event)
      .then((payload) => {
        const routeCopy = angular.copy(this.route);
        if (payload.mainLogisticVehicle) {
          routeCopy.planningResource.mainLogisticsVehicleReference = payload.mainLogisticVehicle;
        }
        if (payload.attachedLogisticVehicle) {
          if (!routeCopy.planningResource.attachedLogisticsVehicleReferences) {
            routeCopy.planningResource.attachedLogisticsVehicleReferences = [];
          }
          routeCopy.planningResource.attachedLogisticsVehicleReferences[0] = payload.attachedLogisticVehicle;
        }
        this._updateRoute(routeCopy);
        // this._updateInternalTask(task)
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error)
      })
  }

  onChangeRouteColor(route) {
    this.commonsDialogService.selectColor(route.color, this.commonsConstants.colorPalletRoutes)
      .then((selectedColor) => {
        const updatedRoute = angular.copy(route);
        updatedRoute.color = selectedColor;
        this._updateRoute(updatedRoute);
      })
  }

  onUpdateBranches(routeId, event) {
    this.branchesDialogService.branchesSelect(event, undefined, this.route.branchIds)
      .then((branchIds) => {
        this._updateBranchesRoute(routeId, branchIds);
      })
  }

  private _updateRoute(route) {
    this.routesService.updateRoute(route);
  }

  private _updateBranchesRoute(id, branchIdsPayload) {
    this.bringozLoaderService.on();
    this.routeRequestsService.updateBranch([id], branchIdsPayload)
      .then(() => {
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error('Failed to update route', error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private _updateInternalTask(task) {
    this.tasksService.updateInternalTask(task)
      .then((internalTask) => {
        const taskIndex = _.findIndex(this.route[this.routeTasksListType], (ta: any) => {
          return ta.id === task.id
        })
        const routeCopy = angular.copy(this.route);
        routeCopy[this.routeTasksListType][taskIndex] = internalTask;
        this.route = routeCopy;
      })
  }

  private _reCreateRoute(route, resourceAllocation: ResourceAllocationTimeWindowExtModel, queries?: ChangeRouteResourceQueryModelModel) {
    this.leanPlanningService.recreateRoute(route.id, resourceAllocation.resourceAllocationId, resourceAllocation.id, "Allocation", resourceAllocation.id, queries)
  }

  private _bindAgent(agentId) {
    if (this.agentRef) {
      this.agentRef.$destroy();
    }

    if (this.agentLocationRef) {
      this.agentLocationRef.$destroy();
    }

    if (agentId) {
      this.agentRef = this.$agent(agentId);
      this.agentLocationRef = this.$agentLocation(agentId);

      this.agentRef.$bindCtrl(this.$scope, this, 'agent');
      // agentLocationRef.$bindCtrl($scope, ctrl, 'agentLocation');
      // agentLocationRef.$registerOnUpdateHandler(ctrl, function(updatedLocation) {
      //     if (ctrl.agent && _.isEqual(updatedLocation.holderId, ctrl.agent.id)) {
      //         ctrl.agent.lastKnownLocation = updatedLocation;
      //     }
      // });
      // ctrl.agent.lastKnownLocation = changes.agentLocation.currentValue;

    } else {
      this.agent = null;
    }

  }

  private getServiceAreaList(serviceAreaIdList: string[]) {
    this.serviceAreasRef.$asyncValues(serviceAreaIdList)
      .then((serviceAreas) => {
        this.serviceAreaList = serviceAreas;
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to get service areas @planningRoute@_addRouteToMap', error);
        }
      })
  }

  private _updateExpandedRoute(routeId: string) {

    const query: RoutesListPayloadModel = {
      ids: [routeId],
      expandServices: false,
      expandTasks: true,
      expandTasksExt: true,
      expandAnalysis: true
    }

    return this.routesService.getRoutesList(query)
      .then((routes) => {
        this.route = routes[0];
        return routes[0];
      });

  }

  private _handleUnpackedDeliveries(route, services, event) {
    let loading = false;
    this.leanPlanningDialogService.handleUnpackedServices(services, event)
      .then((serviceIdsToRemove) => {
        loading = true;
        this.bringozLoaderService.on();
        return this.leanPlanningRequestsService.removeDeliveryFromRoute(serviceIdsToRemove, route.rid)
      })
      .then(() => {
        this.leanPlanningAlertsService.removeUnpackedSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.removeUnpackedError();
          this.$log.error('Failed to remove unpacked deliveries @planningRoute@_handleUnpackedDeliveries', error);
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      });
  }

  private _removeTasksFromRoute(task: TaskModel, event) {
    let loading = false;
    const text = 'Are you sure you want to remove from route?';
    const header = this.$filter('translate')('Remove Deliveries From Route');
    const actions = this.commonsService.getConfirmActions(['Reset Services']);
    this.confirmDialogService.confirmWithActions(header + ' ' + this.route.rid, text, actions, event)
      .then((actionsResponse) => {
        loading = true;
        this.bringozLoaderService.on();
        let serviceIds = task.bundleServiceIdList || [task.serviceId];
        return this.leanPlanningRequestsService.removeDeliveryFromRoute(serviceIds, this.route.rid, actionsResponse[0].enabled);
      })
      .then((route) => {
        // this.route = route;
        this.leanPlanningAlertsService.removeTaskSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.removeTaskError();
          this.$log.error('Failed to remove task from route @planningRoute@onRemoveTaskFromRoute', error);
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }


  private _editRoute(taskIdsOrder, optimizationSettings) {
    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.editRoutes([{
      id: this.route.rid,
      order: taskIdsOrder,
      optimizationSettings: optimizationSettings
    }])
      .then((updatedRoute) => {
        this.route = updatedRoute[0];
        this.routeCopy = undefined;
        this.leanPlanningAlertsService.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.updateError();
          this.$log.error('Failed to change route itinerary @planningRoute@onRouteOrderChange', error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoute', {
    bindings: {
      route: '<',
      metaData: '<?'
    },
    template: require('./planning-route.html').default,
    controller: PlanningRouteCtrl
  });
